module.exports = __webpack_public_path__ + "img/loan_ok.32eebc5c.png";